import type { FC } from "react";
import type { IFeedbackItem } from "../config";
import stars from "/assets/images/stars.svg";

/**
 * Компонент FeedbackCard.
 * Отображает одну карточку отзыва пользователя: имя, рейтинг и текст отзыва.
 * Используется в слайдере отзывов.
 *
 * @returns {ReactNode} JSX-разметка карточки отзыва.
 */
export const FeedbackCard: FC<IFeedbackItem> = ({ name, rating, text }) => {
  const initial = name.charAt(0).toUpperCase();

  return (
    <div className={"flex flex-col max-w-90 items-start gap-6 p-8 mobile:p-4 mobile:gap-4 relative h-full bg-[var(--color-lightGray)] rounded-[3rem] overflow-hidden mobile:overflow-visible"}>
      <div className={"flex items-start gap-4 relative self-stretch rounded-3xl overflow-hidden"}>
        <div className={"w-12 h-12 font-semibold text-[3rem] rounded-full w-13 h-13 aspect-[1] bg-[var(--color-white-40)] text-white flex items-center justify-center text-lg font-semibold"}>
          {initial}
        </div>
        <div className={"flex flex-col items-start gap-1 relative flex-1"}>
          <p className={"relative self-stretch font-semibold text-white subtitle w-full"}>{name}</p>
          <div className={"flex gap-1"}>
            {[ ...Array(Number(rating)) ].map((_, i) => (
              <img
                key={i}
                src={stars}
                alt={"rating star"}
                className={"w-4.5 h-4.5 mobile:w-3.5 mobile:h-3.5"}
              />
            ))}
          </div>
        </div>
      </div>

      <p className={"relative self-stretch text text-white-70"}>
        {text}
      </p>
    </div>
  );
};
